import styled, { FlattenSimpleInterpolation } from 'styled-components';

export const StyledLoader = styled.span<{
  extraStyle?: FlattenSimpleInterpolation;
}>`
  display: block;
  ${({ extraStyle }) => extraStyle}
`;
